import { render, staticRenderFns } from "./Remere.vue?vue&type=template&id=e571d5be&"
import script from "./Remere.vue?vue&type=script&lang=js&"
export * from "./Remere.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports